import React, { Component } from "react";
import Dropdown from "semantic-ui-react/dist/es/modules/Dropdown";
import { Icon } from "semantic-ui-react";
import Select, { components } from "react-select";
import CustomDropdown from "../Charts/ChartsOptionsSidebar/CustomDropdown";

const IndicatorsContainer = ({ children, ...props }) => {
    return (
        <components.IndicatorsContainer {...props}>
            <div className="react-select-control">
                {children}
                {/* <p>hello</p> */}
                <Icon style={{ marginTop: 3 }} name={"caret down"} />
            </div>
        </components.IndicatorsContainer>
    );
};

const customStyles = {
    control: (base) => ({ ...base, border: 0, boxShadow: "none", background: "#F5F6FA", height: "36px", minHeight: "36px" }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return { ...styles, backgroundColor: isFocused ? "#F5F6FA" : null, color: "#1f2e3d", opacity: isDisabled ? 0.5 : 1 };
    },
    dropdownIndicator: (provided, state) => ({
        ...provided,
        transform: state.selectProps.menuIsOpen && "rotate(180deg) translateY(5px)",
    }),

    menuList: (base) => ({
        ...base,
        padding: "7px",
        margin: "4px",
        fontSize: 14,

        "::-webkit-scrollbar": {
            width: "2px",
        },
        "::-webkit-scrollbar-track": {
            background: "white",
        },
        "::-webkit-scrollbar-thumb": {
            background: "white",
        },
        "::-webkit-scrollbar-thumb:hover": {
            background: "white",
        },
    }),
};

class ImpactSelector extends Component {
    state = {};

    handleImpactChange = (e, d) => {
        this.props.handleImpactChange(d);
    };

    render() {
        const aggsIntervalOptions = [
            { key: "TOTAL IMPACT", label: "TOTAL IMPACT", value: "total_impact" },
            { key: "AVERAGE IMPACT", label: "AVERAGE IMPACT", value: "average_impact" },
            { key: "MENTIONS", label: "MENTIONS", value: "mentions" },
        ];

        let obj =
            this.props.appliedFilter && this.props.appliedFilter.arrangeBy
                ? aggsIntervalOptions.find((o) => o.value === this.props.appliedFilter.arrangeBy).value
                : "total_impact";

        return (
            // <Dropdown
            //     value={this.props.aggs_val}
            //     disabled={this.props.loading}
            //     placeholder={obj}
            //     onChange={(e, d) => this.handleImpactChange(e, d.value)}
            //     selection
            //     options={aggsIntervalOptions}
            // />
            <CustomDropdown className="interval-selector" name="Sort By" onChange={this.props.handleImpactChange} value={obj} options={aggsIntervalOptions} />
        );
    }
}

export default ImpactSelector;
